import { RequestService } from "../../../../common/services/RequestService";
import { DELETE_FOOD_PRODUCT } from "./constants";

export const deleteFoodProductRequest = async (orderId, foodProductId) => {
  const response = await RequestService.delete(
    DELETE_FOOD_PRODUCT.replace("{order_id}", orderId).replace(
      "{food_product_list_id}",
      foodProductId
    )
  );
  return response;
};
